export default __webpack_public_path__ + "static/media/Welcome-modal-banner.23e6f671.svg";